import { sendMessageUp } from '@/helpers/iframeMessages';
import isBrowser from '@/helpers/isBrowser';

const createCookie = (name: string, value: string, days?: number): string => {
  if (!isBrowser()) {
    return '';
  }

  // This means that the cookie is created here is different from the one  in widget and here. Should be the same, but that's later.
  sendMessageUp({
    message: 'set-client-cookie',
    value: { token: value },
  });

  const parts = [];
  parts.push(`${name}=${value}`);

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    parts.push(`expires=${date.toUTCString()}`);
  }

  const { host, protocol } = window.location;
  const isHttps = protocol === 'https:';
  const hostName = host.replace(/:\d+$/, '');
  const hostParts = hostName.split('.').reverse();
  const isLocalhost = hostName === 'localhost' || hostName === '127.0.0.1';

  parts.push('path=/');
  parts.push(isHttps ? 'SameSite=None' : 'SameSite=Lax');

  if (isHttps) {
    parts.push('Secure');
  }

  // make cookie available on all subdomains.
  // count on the name being different on different tiers so that qa.noodle.shop and noodle.shop don't get the same cookie.
  // this is to enable scheduling.noodle.shop to have the same cookie as noodle.shop.
  if (!isLocalhost && hostParts.length >= 2) {
    parts.push(`domain=.${hostParts[1]}.${hostParts[0]}`);
  }

  const cookie = parts.join('; ');
  document.cookie = cookie;
  return cookie;
};

export default createCookie;
